import { render } from "./ClientEndpoints.vue?vue&type=template&id=a5226902&scoped=true"
import script from "./ClientEndpoints.vue?vue&type=script&lang=js"
export * from "./ClientEndpoints.vue?vue&type=script&lang=js"

import "./ClientEndpoints.vue?vue&type=style&index=0&id=a5226902&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5226902"]])

export default __exports__